import React from 'react';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-black overflow-hidden h-screen min-h-[700px] flex flex-col justify-end" data-id="element-92">
      {/* Background Video con efecto Ken Burns (zoom lento cinematográfico) */}
      <video autoPlay loop muted playsInline preload="metadata" disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" className="absolute inset-0 w-full h-full object-cover hero-kenburns" data-id="element-93">
        <source src="https://cdn.magicpatterns.com/uploads/rYQE36s9PagzYVcs5g1adp/32858-394513919_medium.mp4" type="video/mp4" data-id="element-94" />
      </video>

      {/* Cinematic Overlay - estilo trailer de película */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/95" data-id="element-95"></div>

      {/* Letterbox bars superior e inferior (efecto cinema 2.35:1) */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-black/80 to-transparent z-10 pointer-events-none" data-id="element-96"></div>

      {/* Vignette sutil para enfoque cinematográfico */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.6) 100%)'
    }} data-id="element-97"></div>

      {/* Contenido cinematográfico (anclado abajo como en un trailer) */}
      <div className="relative z-20 max-w-6xl mx-auto px-6 lg:px-8 pb-24 md:pb-32 w-full" data-id="element-98">
        {/* Etiqueta superior elegante */}
        <div className="flex items-center gap-3 mb-6 animate-[fadeInUp_1.2s_ease-out]" data-id="element-99">
          <div className="h-px w-12 bg-warm" data-id="element-100"></div>
          <span className="text-warm font-bold tracking-[0.3em] text-xs md:text-sm uppercase" data-id="element-101">
            Sylmar · Los Angeles
          </span>
        </div>

        {/* Título principal estilo cine */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white tracking-tight mb-6 leading-[0.95] max-w-4xl animate-[fadeInUp_1.5s_ease-out]" style={{
        textShadow: '0 4px 20px rgba(0,0,0,0.8)'
      }} data-id="element-102">
          Tu comunidad <br data-id="element-103" />
          <span className="text-warm italic font-serif" data-id="element-104">necesita tu voz.</span>
        </h1>

        {/* Subtítulo elegante */}
        <p className="text-lg md:text-xl text-white/90 mb-10 leading-relaxed max-w-2xl font-light animate-[fadeInUp_1.8s_ease-out]" style={{
        textShadow: '0 2px 8px rgba(0,0,0,0.9)'
      }} data-id="element-105">
          Un concilio. Una visión. Miles de voces construyendo el futuro de
          Sylmar.
          <span className="block mt-2 text-base text-white/70 italic" data-id="element-106">
            One council. One vision. Thousands of voices shaping Sylmar's
            future.
          </span>
        </p>
      </div>

      {/* Indicador de scroll (estilo cine) */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce" data-id="element-107">
        <ChevronDown className="w-8 h-8 text-white/60" data-id="element-108" />
      </div>

      {/* Animaciones CSS personalizadas */}
      <style data-id="element-109">{`
        .hero-kenburns {
          will-change: transform;
          transform-origin: center center;
          backface-visibility: hidden;
          animation: kenburns 40s ease-in-out infinite alternate;
        }
        @keyframes kenburns {
          0% { transform: translate3d(0, 0, 0) scale(1.02); }
          100% { transform: translate3d(-1.5%, 1%, 0) scale(1.12); }
        }
        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>;
}